
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSuccessIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 80,
  height: 80,
  viewBox: "0 0 81 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.94 42.26c1.605-2.099 4.299-3.456 6.861-3.456h9.815l-3.374-10.097a.991.991 0 0 1-.035-.139c-1.393-7.676 1.357-11.402 4.396-12.33 2.401-.733 4.879.276 5.762 2.349l7.343 17.229 7.899 5.037c.485-1.851 2.159-3.22 4.144-3.22h7.462c2.364 0 4.287 1.94 4.287 4.327v27.706c0 2.386-1.923 4.327-4.287 4.327h-7.462c-1.5 0-2.822-.782-3.588-1.963-1.964 1.813-5.79 1.97-8.927 1.97-.337 0-.667-.002-.985-.004l-.815-.002h-17.07c-2.13 0-3.951-.914-5.412-2.714-1.154-1.422-2.06-3.381-2.692-5.821l-4.565-17.615c-.494-1.907-.053-3.89 1.243-5.583zm40.497 27.406c0 1.288 1.038 2.336 2.314 2.336h7.462c1.276 0 2.314-1.048 2.314-2.336V41.96c0-1.288-1.038-2.336-2.314-2.336h-7.462c-1.276 0-2.314 1.048-2.314 2.336v27.706zM14.606 47.34l4.564 17.614c.833 3.216 2.584 7.048 6.195 7.048h17.07l.826.003c2.826.016 7.097.039 8.64-1.51.384-.386.563-.843.563-1.438v-25.94l-9.068-5.783a.993.993 0 0 1-.38-.448l-7.463-17.513c-.478-1.122-1.962-1.662-3.38-1.229-2.214.676-4.17 3.658-3.039 9.995l3.79 11.343c.102.304.052.639-.133.899a.983.983 0 0 1-.801.415H20.8c-1.943 0-4.073 1.078-5.3 2.682-.646.844-1.326 2.2-.895 3.862z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M44.5 14.5 50 9M16.5 9l5.5 5.5M33.39 3v7.778",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2,
  strokeLinecap: "round"
})));

      const __svgRaw = "<svg width=\"80\" height=\"80\" viewBox=\"0 0 81 80\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M13.94 42.26c1.605-2.099 4.299-3.456 6.861-3.456h9.815l-3.374-10.097a.991.991 0 0 1-.035-.139c-1.393-7.676 1.357-11.402 4.396-12.33 2.401-.733 4.879.276 5.762 2.349l7.343 17.229 7.899 5.037c.485-1.851 2.159-3.22 4.144-3.22h7.462c2.364 0 4.287 1.94 4.287 4.327v27.706c0 2.386-1.923 4.327-4.287 4.327h-7.462c-1.5 0-2.822-.782-3.588-1.963-1.964 1.813-5.79 1.97-8.927 1.97-.337 0-.667-.002-.985-.004l-.815-.002h-17.07c-2.13 0-3.951-.914-5.412-2.714-1.154-1.422-2.06-3.381-2.692-5.821l-4.565-17.615c-.494-1.907-.053-3.89 1.243-5.583zm40.497 27.406c0 1.288 1.038 2.336 2.314 2.336h7.462c1.276 0 2.314-1.048 2.314-2.336V41.96c0-1.288-1.038-2.336-2.314-2.336h-7.462c-1.276 0-2.314 1.048-2.314 2.336v27.706zM14.606 47.34l4.564 17.614c.833 3.216 2.584 7.048 6.195 7.048h17.07l.826.003c2.826.016 7.097.039 8.64-1.51.384-.386.563-.843.563-1.438v-25.94l-9.068-5.783a.993.993 0 0 1-.38-.448l-7.463-17.513c-.478-1.122-1.962-1.662-3.38-1.229-2.214.676-4.17 3.658-3.039 9.995l3.79 11.343c.102.304.052.639-.133.899a.983.983 0 0 1-.801.415H20.8c-1.943 0-4.073 1.078-5.3 2.682-.646.844-1.326 2.2-.895 3.862z\" fill=\"#000000\"/>\r\n    <path d=\"M44.5 14.5 50 9M16.5 9l5.5 5.5M33.39 3v7.778\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2\" stroke-linecap=\"round\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/SuccessIcon.db6dc7ae36b1b0718f809d3a66d1f0a7.svg"),
        {
          React: SvgSuccessIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      